import { createSlice, nanoid, type PayloadAction } from "@reduxjs/toolkit";

import type { MappingRule, MappingRuleInput } from "@/types/api";

interface MappingState {
  items: MappingRule[];
}

const seed: MappingRule[] = [
  {
    id: "mr-1",
    cloudbeds_code: "RR-STD",
    cloudbeds_kind: "gl",
    sfm_nominal: "4000-01",
    vat_code: "VAT7",
    ledger_category: "accommodation",
    active_from: "2026-01-01",
    active_to: null,
    created_by: "dev-user",
    created_at: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "mr-2",
    cloudbeds_code: "RR-DLX",
    cloudbeds_kind: "gl",
    sfm_nominal: "4000-02",
    vat_code: "VAT7",
    ledger_category: "accommodation",
    active_from: "2026-01-01",
    active_to: null,
    created_by: "dev-user",
    created_at: "2026-01-01T00:00:00.000Z",
  },
  {
    id: "mr-3",
    cloudbeds_code: "BAR",
    cloudbeds_kind: "txn_type",
    sfm_nominal: "4100-01",
    vat_code: "VAT18",
    ledger_category: "fnb",
    active_from: "2026-01-01",
    active_to: null,
    created_by: "dev-user",
    created_at: "2026-01-01T00:00:00.000Z",
  },
];

const initialState: MappingState = { items: seed };

const slice = createSlice({
  name: "mappingRules",
  initialState,
  reducers: {
    addRule(state, action: PayloadAction<{ input: MappingRuleInput; actor?: string }>) {
      const { input, actor } = action.payload;
      const id = `mr-${nanoid(6)}`;
      state.items.unshift({
        id,
        cloudbeds_code: input.cloudbeds_code,
        cloudbeds_kind: input.cloudbeds_kind,
        sfm_nominal: input.sfm_nominal,
        vat_code: input.vat_code ?? null,
        ledger_category: input.ledger_category ?? null,
        active_from: input.active_from,
        active_to: null,
        created_by: actor ?? "dev-user",
        created_at: new Date().toISOString(),
      });
    },
    updateRule(
      state,
      action: PayloadAction<{ id: string; patch: Partial<MappingRule> }>,
    ) {
      const row = state.items.find((r) => r.id === action.payload.id);
      if (row) Object.assign(row, action.payload.patch);
    },
    softDeleteRule(state, action: PayloadAction<string>) {
      const row = state.items.find((r) => r.id === action.payload);
      if (row) row.active_to = new Date().toISOString().slice(0, 10);
    },
    deleteRule(state, action: PayloadAction<string>) {
      state.items = state.items.filter((r) => r.id !== action.payload);
    },
  },
});

export const { addRule, updateRule, softDeleteRule, deleteRule } = slice.actions;
export default slice.reducer;
